import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import { captureAffiliateRef } from "./common/affiliateTracking";

function App() {
  // Record the visit when someone arrives via an affiliate link (?ref=CODE).
  useEffect(() => {
    captureAffiliateRef();
  }, []);

  useEffect(() => {
    let nativeLang = "en";
    try {
      const userJson = localStorage.getItem("user");
      if (userJson) {
        const userObj = JSON.parse(userJson);
        nativeLang = userObj?.native_language || "en";
      }
    } catch (e) {
      console.error("Error reading user from localStorage in App.js", e);
    }

    if (nativeLang !== "en") {
      if (!document.getElementById("google_translate_element")) {
        const translateDiv = document.createElement("div");
        translateDiv.id = "google_translate_element";
        translateDiv.style.position = "absolute";
        translateDiv.style.top = "-9999px";
        translateDiv.style.left = "-9999px";
        document.body.appendChild(translateDiv);
      }

      window.googleTranslateElementInit = () => {
        if (window.google && window.google.translate) {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: "en",
              autoDisplay: false,
            },
            "google_translate_element",
          );
        }
      };

      if (!document.querySelector('script[src*="translate.google.com"]')) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
          "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        document.body.appendChild(script);
      }

      const showToolbar =
        localStorage.getItem("show_google_translate_toolbar") === "true";
      if (showToolbar) {
        document.body.classList.add("show-translate-toolbar");
      } else {
        document.body.classList.remove("show-translate-toolbar");
      }
    } else {
      document.body.classList.remove("show-translate-toolbar");
    }
  }, []);

  return (
    <>
      <ToastContainer />
      <AppRoutes />
    </>
  );
}

export default App;
